import { Spade, Calculator, Dice5 } from 'lucide-react';

import { type TaskResponse } from '../../client';

interface Props {
  task: TaskResponse;
}

export function MiniGameIcon({ task }: Props) {
  const Icon = task.type === 'memory' ? Spade : task.type === 'equation' ? Calculator : Dice5;
  return <Icon className="w-5 h-5 text-text-muted" />;
}
